<template>
  <div class="col-md-9 pt-3 p-4 mt-1">
    <h1 class="header-form-loan-info text-uppercase mb-4">Update Investment Detail</h1>
    <hr class="bg-dark" />
    <form v-if="investment._id" @submit.prevent="investmentUpdate">
      <div class="form-group">
        <label for="investmentId">ID</label>
        <input type="text" class="form-control text-left" v-model="investment.investmentId" disabled />
      </div>

      <div class="form-group">
        <label for="invsetmentName">Investor Name</label>
        <input
          type="text"
          class="form-control text-left"
          v-model="investment.priorityUser.name"
          disabled
        />
      </div>

      <div class="form-group">
        <label for="investmentAmount">Amount</label>
        <input :disabled="disableField" type="text" class="form-control text-left" v-model="investment.amount" />
      </div>

      <div class="form-group">

        <label for="investmentAmount">Currency</label>
        <select :disabled="disableField" v-model="investment.currency" class="custom-select">
          <option value="IDR">IDR</option>
          <option value="USD">USD</option>
        </select>
      </div>

      <div class="form-group">
        <label for="investmentTimePeriod">Time Period</label>
        <select :disabled="disableField" v-model="investment.timePeriod" class="form-control text-left">
          <option
            v-for="(period) in investmentPeriod"
            :key="period"
            :value="period"
            :selected="true"
          >{{ period }} tahun</option>
        </select>
      </div>

      <!-- <div class="form-group">
        <label for="investmentDate">Investment Date</label>
        <input type="text" id="datepicker" autocomplete="off" class="form-control text-left" />
      </div>-->

      <div class="form-group">
        <label for="investmentStatus">Investment Status</label>
        <select v-model="investment.status" class="form-control text-left">
          <option
            v-for="(status, idx) in investmentStatus"
            :key="idx"
            :value="status"
            :selected="true"
          >{{ status }}</option>
        </select>
      </div>

      <button type="submit" class="btn btn-success ml-2" id="buttons">Simpan</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "adminInvestmentUpdate",
  data() {
    return {
      investmentStatus: ["unpaid", "paid", "pending_authorize", "canceled"],
      investmentPeriod: [2, 3],
      investment: {},
      disableField: false,
    };
  },
  created() {
    this.$axios
      .get(`/admin/v1/priority/investments/${this.$route.params.id}`)
      .then(res => {
        this.investment = res.data.data;
        this.investment.amount = this.$options.filters.displayAmount(this.investment.amount);

        if (this.investment.status === "paid" || this.investment.status === "canceled") {
          this.disableField = true;
        }
      })
      .catch(err => {
        this.$swal({ text: err });
      });
  },
  mounted() {
    $("#datepicker").datepicker();
  },
  methods: {
    investmentUpdate() {
      let amountStr = this.investment.amount.replace(/,/g, '')
      this.investment.amount = Number(amountStr)

      this.$axios
        .put(
          `/admin/v1/priority/investments/${this.investment._id}`,
          this.investment
        )
        .then(res => {
          this.$swal({ text: "Success update investment detail" });
          this.$router.push({ name: "adminInvestment" });
        })
        .catch(err => {
          this.$swal({ text: err });
        });
    }
  }
};
</script>